// A2F-546: onboarding page footer (matches the design's final row).
// Separate from components/TermsPrivacyFooter.tsx which is the form-level
// consent block rendered inside the SignupForm.

import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="max-w-5xl mx-auto px-6 py-10 text-xs text-slate-500 flex flex-wrap items-center gap-x-5 gap-y-2">
      <span>&copy; A2 Foundry, Inc. 2026</span>
      <a
        href="https://chronabio.ai/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-brand-charcoal"
      >
        Privacy
      </a>
      <a
        href="https://chronabio.ai/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-brand-charcoal"
      >
        Terms
      </a>
      <Link to="/pricing" className="hover:text-brand-charcoal">
        Pricing
      </Link>
      <a
        href="https://chronabio.ai/support"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-brand-charcoal"
      >
        Support
      </a>
    </footer>
  )
}
